import { SelectListItem } from "../../Components/Layout/Selectors/General/GeneralSelect"
import { AcademyEvent, AcademyVerified } from "../../Api/Events/Academy/academyEvents.types"
import { ACADEMY_ACTIONS } from "./academyReducer"

export type AcademyFilterObject = {
  participant?: string
  state?: string
  month?: string
  training?: string
}

export type ParticipantType = {
  id: number
  label: string
  value: string
}

export const participantTypes: ParticipantType[] = [
  { id: 0, label: 'All', value: 'all' },
  { id: 1, label: 'Boys', value: 'boys' },
  { id: 2, label: 'Girls', value: 'girls' },
]

export type AcademyHookReturns = {
    academyEvents: AcademyEvent[]
    verifiedClubs: AcademyVerified[]
    stateList: SelectListItem[]
    monthList: SelectListItem[]
    trainingList: SelectListItem[]
    stateSelect: string
    monthSelect: string
    trainingSelect: string
    participantSelect: string
    filteredList: AcademyEvent[]
    loading: boolean
    verifiedLoading: boolean
    handleFilterChange: (filterType: string, value: string) => void
    handleReset: () => void
    getGameWeekendEvents: (market: string) => AcademyEvent | undefined
    returnFilteredEvents: (filterObj: AcademyFilterObject) => AcademyEvent[]
  }

  export type AcademySelects = {
    participant: string
    month: string
    state: string
    training: string
  }
  
  export type AcademyDropdownLists = {
    states: SelectListItem[]
    months: SelectListItem[]
    trainings: SelectListItem[]
  }
  
  export type AcademyState = {
    academyEvents: AcademyEvent[]
    filteredList: AcademyEvent[]
    verifiedClubs: AcademyVerified[]
    selects: AcademySelects
    dropdownLists: AcademyDropdownLists
    loading: boolean
    verifiedLoading: boolean
  }
  
  export type AcademyAction =
    | { type: typeof ACADEMY_ACTIONS.SET_ACADEMY_EVENTS; payload: AcademyEvent[] }
    | { type: typeof ACADEMY_ACTIONS.SET_FILTERED_LIST; payload: AcademyEvent[] }
    | { type: typeof ACADEMY_ACTIONS.SET_VERIFIED_CLUBS; payload: AcademyVerified[] }
    | { type: typeof ACADEMY_ACTIONS.SET_SELECTS; payload: Partial<AcademySelects> }
    | { type: typeof ACADEMY_ACTIONS.SET_PARTICIPANT_SELECT; payload: ParticipantType }
    | {
        type: typeof ACADEMY_ACTIONS.SET_DROPDOWN_LISTS
        payload: Partial<AcademyDropdownLists>
      }
    | { type: typeof ACADEMY_ACTIONS.SET_LOADING; payload: boolean }
    | { type: typeof ACADEMY_ACTIONS.SET_VERIFIED_LOADING; payload: boolean }
    | { type: typeof ACADEMY_ACTIONS.RESET_FILTERS }
